<template>
  <img id="base_written_logo"
    src="../../assets/images/stratumblue_white_outline_logo.png"
    :class="logoClasses"
    style="width: 130px"
  >
</template>
<script>
export default {
  props: ["logoClasses"]
};
</script>

    



// WEBPACK FOOTER //
// src/components/public/BaseWrittenLogo.vue